import React from 'react';
import { changeLang, Lang } from '../../states/query';
import { makeStyles,  createStyles } from '@material-ui/core';
import { getDataVersion } from '../../services/ekispert/api';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() =>
  createStyles({
    subtitle: {
      textDecoration: 'underline'
    },
    annotation: {
      fontSize: '12px',
    }
  }),
);

const ServiceAboutBody: React.FC = () => {
  const [copyRights, setCopyRights] = React.useState<string[]> ([]);
  const [ init, setInit ] = React.useState(true);
  const { i18n } = useTranslation();
  const classes = useStyles();
  const lang = changeLang(i18n.language)
  React.useEffect(()=>{
    if(init) {
      getCopyRights();
      setInit(false);
    }
  }, [init]);
  const getCopyRights = async () => {
    const dataVersion = await getDataVersion();
    const copyRights = dataVersion.Copyrights.text.split('\n');
    // 先頭の交承だけANAのものに差し替え
    copyRights[0] = "交承 令和2年 177号";
    setCopyRights(copyRights);
  }

  const ServiceAboutBodyJP: React.FC = () => {
    return (
      <div>
        <h3 className={classes.subtitle}>このサービスについて</h3>
        <p>航空便の最新運航情報*3とターミナルや搭乗口・保安検査場などのロケーション情報を経路検索サービスに統合し、「出発地から搭乗まで」「降機から最終目的地まで」の一気通貫なルート案内を行うことでシームレスな移動体験をご提供いたします。また、地上交通機関との連携<sup>*1</sup> により、空港までのアクセスの予約・決済<sup>*2</sup>  も可能になります。</p>
        <p className={classes.annotation}>*1. 地上交通機関との連携は順次拡大してまいります。</p>
        <p className={classes.annotation}>*2. 地上交通機関サイトでの予約となります。</p>
        <p className={classes.annotation}>*3. Peach、JAC（日本エアコミューター）、天草エアラインとのコードシェア便または JAL,Spring Japan運航便は反映されません。詳しくは各社ホームページをご確認ください。</p>
        <h3 className={classes.subtitle}>推奨環境</h3>
        <p>●PC・スマートフォン（ブラウザ）</p>
        <p>Google chrome（最新版）</p>
        <p>Safari(最新版)</p>
        <p>●スマートフォン（OS）</p>
        <p>iOS11以降</p>
        <p>Android5.0以降</p>
        <h3 className={classes.subtitle}>時刻表について</h3>
        {
          copyRights && copyRights.map((x, index)=>{
            if(x){
              return (
                <p key={index}>{x}</p>
              )
            }
            return null;
          })
        }
        <p>※経路情報提供元：駅すぱあと</p>
        <p>「駅すぱあと」は株式会社ヴァル研究所の登録商標です。</p>
        <p>※鉄道運行情報：列車遅延など、鉄道の運行情報もご確認いただけます。</p>
        <p>鉄道運行情報提供元：株式会社レスキューナウ</p>
      </div>
    );
  }

  const ServiceAboutBodyEN: React.FC = () => {
    return (
      <div>
        <h3 className={classes.subtitle}>What is Airport Access</h3>
        <p>You can now get information on how to get to the departure airport and board your flight, and also on how to get to your final destination after disembarkation.</p>

        <h3 className={classes.subtitle}>Recommended Environment</h3>
        <p>●PC /Smartphone―Browser</p>
        <p>Google Chrome latest version</p>
        <p>Safari latest version</p>
        <p>●Smartphone―APP</p>
        <p>iOS11</p>
        <p>Android 5.0</p>

        <h3 className={classes.subtitle}>About Timetable</h3>
        <p>【Kosho Reiwa 2<sup>nd</sup>,　No117】</p>
        <p>・JR timetable data is provided by KOTSUSHINBUNSHA. This data has been based on the latest edition. No part of this site may be distributed, modified and reproduced in any form without our written permission.</p>
        <p>・JR bus timetable data is provided by KOTSUSHINBUNSHA. This data has been based on the latest edition. No part of this site may be distributed, modified and reproduced in any form without our written permission</p>
        <p>・Meitetsu Bus timetable is based on data created by Meitetsu Bus Co., Ltd. However, some bus stop pole information was processed by Val Laboratory Corporation at their own responsibility. In addition, some contents have been processed by Val Laboratory Corporation at their own responsibility.</p>

        <p>*Route Information provided by Eki-spert</p>
        <p> “Eki-Spert”  is registered trademark of Val Laboratory</p>
        <p>*You can also check train operation status such as train delays.</p>
        <p>Information provided by  Rescuenow Inc. </p>
      </div>
    )
  }

  if(lang === Lang.ja){
    return <ServiceAboutBodyJP/>
  } else {
    return <ServiceAboutBodyEN/>
  }
}

export default ServiceAboutBody;
